import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { Biohazard, FileText, LogOut, User } from "lucide-react";
import { FullscreenButton } from "./FullscreenButton";

const TICKER = [
  "SPORE BLOOM ACTIVE IN SECTORS 3, 7 AND 12",
  "NOT EVERY SYMPTOM MEANS INFECTION — LEARN WHICH ONES DO",
  "SPECIALISTS ARE ROTATING BETWEEN QUARANTINE WINGS — ACT FAST",
  "DO NOT REMOVE RESPIRATORS NEAR DAMP CORNERS",
  "REPORT ANY ORANGE FRINGE COLOURATION IMMEDIATELY",
];

export const SporePage = ({ children }) => (
  <div className="min-h-screen bg-[#070A0E] text-slate-100 relative spore-grain">
    <div className="spore-scanlines" aria-hidden="true" />
    {children}
  </div>
);

export const HazardTicker = () => (
  <div className="bg-[#FF2E63] text-black overflow-hidden border-b border-red-900" data-testid="hazard-ticker">
    <div className="spore-ticker flex whitespace-nowrap w-max py-1.5 font-tac text-xs tracking-[0.2em]">
      {[...TICKER, ...TICKER].map((t, i) => (
        <span key={i} className="px-8">⚠ {t}</span>
      ))}
    </div>
  </div>
);

export const SporeHeader = ({ children }) => (
  <header className="sticky top-0 z-40 bg-[#070A0E]/95 backdrop-blur-md border-b border-slate-800">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-4 flex items-center justify-between gap-4 flex-wrap">
      <Link to="/" data-testid="brand-home-link" className="flex items-center gap-3">
        <Biohazard className="h-8 w-8 text-[#FF2E63] spore-spin-slow" />
        <div>
          <p className="font-display text-xl font-bold tracking-tight text-slate-100 leading-none">
            PROJECT SP<span className="text-[#FF2E63]">-ORE</span>
          </p>
          <p className="font-tac text-[10px] tracking-[0.25em] text-slate-500 mt-1">RESTRICTED // LEVEL-5 // LETHAL BIOGENIC</p>
        </div>
      </Link>
      <div className="flex items-center gap-2 sm:gap-3 flex-wrap">
        {children}
        <FullscreenButton />
      </div>
    </div>
  </header>
);

const btn = "font-tac text-xs tracking-widest uppercase px-3 py-2 rounded-sm border transition-[background-color,border-color,color] duration-200 flex items-center gap-2 focus:outline-none focus:ring-2 focus:ring-cyan-400";

export const HeaderActions = ({ currentUser, onLogout }) => {
  const navigate = useNavigate();
  return (
    <>
      <span data-testid="current-user-label" className="hidden sm:flex items-center gap-2 font-tac text-xs text-slate-400 px-2">
        <User className="h-3.5 w-3.5 text-cyan-400" /> {currentUser}
      </span>
      <button type="button" data-testid="open-spore-index-btn" onClick={() => navigate("/spore-index")} className={`${btn} border-cyan-700/60 text-cyan-300 hover:bg-cyan-950/60`}>
        <FileText className="h-3.5 w-3.5" /> Symptom Index
      </button>
      <button type="button" data-testid="logout-btn" onClick={onLogout} className={`${btn} border-red-800/70 text-red-300 hover:bg-red-950/60`}>
        <LogOut className="h-3.5 w-3.5" /> Logout
      </button>
    </>
  );
};

export const sporeBtn = {
  primary: `${btn} border-[#FF2E63] bg-[#FF2E63] text-black font-bold hover:bg-[#ff4d7a] justify-center`,
  ghost: `${btn} border-slate-700 text-slate-300 hover:border-cyan-500/60 hover:text-cyan-200 justify-center`,
  success: `${btn} border-emerald-500/70 bg-emerald-950/50 text-emerald-200 hover:bg-emerald-900/60 justify-center`,
};
